import { mapState } from "vuex";
export default {
  data() {
    return {
      successPath: "/match/-2",
      backPath: "/match/-2",
      submitLoading: false,
      pwdHide: {
        // 密码是否显示
        password: true,
        repeatPassword: true,
        withdrawPassword: true,
      },
      pxHide: {
        // 是否显示prefix
        phone: "icon-shouji1",
        vrifyCode: "icon-anquan1",
        password: "icon-lock",
      },
    };
  },
  computed: {
    ...mapState({
      showLogin: (state) => state.showLogin,
      showRegister: (state) => state.showRegister,
    }),
  },
  created() {
    this.backPath = this.$route.query.backPath || "/match/-2";
    this.successPath = this.$route.query.successPath || "/match/-2";
  },
  methods: {
    changeLiveChat(show) {
      // 改变livechat
      if (this.$route.path === "/match/-2" || this.$route.path === "/Service") {
        let type = show ? "minimize" : "hide";
        if (window.LiveChatWidget) window.LiveChatWidget.call(type);
      }
    },

    handleSubmit(formName) {
      const Fname = formName || "ruleForm";
      // console.log(this.$refs[Fname])
      for (let i in this[Fname])
        this.$set(this[Fname], i, this[Fname][i].replace(/(^\s*)|(\s*$)/g, ""));
      this.$refs[Fname].validate((valid) => {
        if (valid) {
          this._submit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    resetRuleForm(Fname = "ruleForm") {
      this.$refs[Fname].resetFields();
    },

    updateVrifycode(v) {
      // 更新图形验证码
      this.$set(this.ruleForm, "timestamp", v);
    },

    handleJump(path) {
      // 跳转新页面
      this.$router.replace({ path });
    },
  },
  destroyed() {},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/mixins/system-form.js